import { MatDialog } from '@angular/material/dialog';
import { FlowStepHandleResult, HandleResultType, StepControl, AbstractStepController, StepControlType, WizardServiceLocator, DialogService } from '@sdbn/common';
import { ContextChange } from '@sdbn/common';
import { AppServerAPI } from '@sdbn/common';
import { ResponseStatus } from '@sdbn/common';
import { LogContainer } from '@sdbn/tmc-common';
import { TerminalContextConstants } from '@sdbn/tmc-common';
import { TerminalVisitorRegistration } from '../widgets/terminal/visitor-registration.model';

export class VisitorRegistrationWithCodeController extends AbstractStepController {

  private dialogService: DialogService;
  
  private checkInYardDisabled = false;

  constructor(
  ) {
    super();
    this.dialogService = WizardServiceLocator.injector.get(DialogService);
  }

  onContextChange(contextChange: ContextChange) {
    if (contextChange.key === TerminalContextConstants.registrationCode && contextChange.value != null && contextChange.value.replace(/\s+/g, '').length === 10) {
      this.onOnRegistrationCode();
    }
  }

  onRegisterToDashboardContext() {

    const dashboardConfiguration = this.wizardComponent.currentStep.dashboardConfiguration;
    if (dashboardConfiguration != null) {
      if (dashboardConfiguration?.checkInYardDisabled != null) {
        this.checkInYardDisabled = dashboardConfiguration?.checkInYardDisabled;
      }
    }
  }

  onOnRegistrationCode() {

    const appServerAPI = WizardServiceLocator.injector.get(AppServerAPI);

    this.dashboardContext.setContextValue(TerminalContextConstants.isLoading, true);
    return appServerAPI.execute(`/terminal/registration/visitor/code`, {
      code: this.dashboardContext.getContextValue(TerminalContextConstants.registrationCode)
    }).toPromise().then((response: TerminalVisitorRegistration) => {
      this.dashboardContext.setContextValue(TerminalContextConstants.isLoading, false);
      this.dashboardContext.setContextValue(TerminalContextConstants.responseMessages, response.responseMessages);
      if (response.status !== ResponseStatus.FAILED) {

        const registration = new TerminalVisitorRegistration(response);

        this.dashboardContext.setContextValue(TerminalContextConstants.numberPlate, registration.numberPlate);
        this.dashboardContext.setContextValue(TerminalContextConstants.lastname, registration.name);
        this.dashboardContext.setContextValue(TerminalContextConstants.firstname, registration.firstname);
        this.dashboardContext.setContextValue(TerminalContextConstants.company, registration.company);
        this.dashboardContext.setContextValue(TerminalContextConstants.gcCaseId, registration.gcCaseId);
        this.dashboardContext.setContextValue(TerminalContextConstants.registrationId, registration.registrationId);
        this.dashboardContext.setContextValue(TerminalContextConstants.reasonForVisit, registration.reason);
        this.dashboardContext.setContextValue(TerminalContextConstants.visitedPerson, registration.visitedPerson);
        this.dashboardContext.setContextValue('needsAreaAccess', registration.needsAreaAccess);
        this.dashboardContext.setContextValue('entranceBarrierSecuredAreaNeeded', registration.needsAreaAccess);
        this.dashboardContext.setContextValue('visitorType', registration.visitorType);
        this.dashboardContext.setContextValue('inviteAdditionalVisitorsAllowed', registration.inviteAdditionalVisitorsAllowed);
        this.dashboardContext.setContextValue('instructionsDone', registration.instructionsDone);
        this.dashboardContext.setContextValue('inviterId', registration.inviterId);
        if (!this.checkInYardDisabled && registration.inYard) {
          const logContainer: LogContainer = this.dashboardContext.context.get(TerminalContextConstants.logContainer);
          logContainer.addLog('start leave process');
          this.wizardComponent.handoverToFlow('registration-terminal-visitor-leave');
        } else {
          const logContainer: LogContainer = this.dashboardContext.context.get(TerminalContextConstants.logContainer);
          logContainer.addLog('register visitor manually started');
          this.onOnRegistrationCodeValid();
        }
      } else {
        this.dashboardContext.setContextValue(TerminalContextConstants.responseMessages, response.responseMessages);
      }
    }, error => {
      // TODO specify what happens for bad codes
    });
  }

  private onOnRegistrationCodeValid() {
    this.wizardComponent.next();
  }


  public handleFlow(): FlowStepHandleResult {
    this.wizardComponent.startInactivityMonitoring();
    const logContainer: LogContainer = this.dashboardContext.context.get(TerminalContextConstants.logContainer);
    logContainer.addLog('register with code started');

    const result = new FlowStepHandleResult();
    result.type = HandleResultType.DASHBOARD;

    return result;
  }

  private cancel() {
    const matDialog = WizardServiceLocator.injector.get(MatDialog);

    this.dialogService.showConfirm(
      'tmc-yard.widgets.registration-terminal.cancel-dialog.title',
      'tmc-yard.widgets.registration-terminal.cancel-dialog.message'
    ).afterClosed().subscribe(confirm => {
      if (confirm) {
        this.wizardComponent.stopInactivityMonitoring();
        this.wizardComponent.restartWizard();
      }
    });

  }

  getControls(): StepControl[] {
    const controls = new Array<StepControl>();

    let spacer = new StepControl();
    spacer.type = StepControlType.SPACER_GROW;
    controls.push(spacer);

    const cancelControl = new StepControl();
    cancelControl.labelDictionaryKey = 'tmc-yard.common.action.cancel';
    cancelControl.type = StepControlType.BUTTON_STROKED;
    cancelControl.iconBeforeCss = 'fa-thin fa-xmark';
    cancelControl.controlAction = this.cancel.bind(this);
    controls.push(cancelControl);


    const showCreateNewRegistrationButton = this.wizardComponent.currentStep.dashboardConfiguration?.showCreateNewRegistrationButton;

    this.dashboardContext.setContextValue('newRegistrationEnabled', showCreateNewRegistrationButton == true);
    this.dashboardContext.setContextValue('qrCodeScanEnabled', this.wizardComponent.currentStep.dashboardConfiguration?.qrCodeScanEnabled == true);


    return controls;
  }
}
